import './CreditInfo.less';

import React from 'react';
import { Progress, Skeleton, Tooltip } from 'antd';
import { useCreditBalance } from '../../hooks/useCreditBalance';
import { getCreditDisplayText } from '../../utils/creditUtils';
import CreditButton from '../CreditButton/CreditButton';
import { formatDate } from '../../utils/timeUtils';
import { useUserAccess } from '../../hooks/useUserAccess';

const CreditInfo: React.FC = () => {
  const balanceInfo = useCreditBalance();
  const { isLoading, totalCredits, usedCredits, warningElement } = balanceInfo;
  const { currentAccount } = useUserAccess();

  return (
    <div
      className="credit-info"
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      {isLoading ? (
        <>
          <div className="credit-info-header">
            <div className="credit-info-title">
              <Skeleton
                loading
                active
                paragraph={false}
                style={{ width: 80 }}
              />
            </div>
            <div className="credit-info-value">
              <Skeleton
                loading
                active
                paragraph={false}
                style={{ width: 80 }}
              />
            </div>
          </div>
          <Skeleton loading active paragraph={false} />
        </>
      ) : (
        <>
          <div className="credit-info-header">
            <div className="credit-info-title">
              <span>Credits used:</span>
            </div>
            <div className="credit-info-value">
              <span>{getCreditDisplayText(currentAccount, balanceInfo)}</span>
            </div>
          </div>

          <Tooltip
            title={`${usedCredits}/${totalCredits} monthly credits used`}
            placement="bottom"
          >
            <Progress
              className="credit-info-progress"
              percent={
                totalCredits > 0
                  ? Math.round((usedCredits * 100) / totalCredits)
                  : 0
              }
              size="default"
              strokeColor="var(--primary-color)"
              showInfo={false}
            />
          </Tooltip>

          {balanceInfo.nextRenewalDate && (
            <div className="credit-info-reset-date">
              Credits reset on {formatDate(balanceInfo.nextRenewalDate)}
            </div>
          )}

          {balanceInfo.oneTimeCreditsRemaining > 0 && (
            <div className="credit-info-bonus">
              Includes {balanceInfo.oneTimeCreditsRemaining} one-time credits
            </div>
          )}

          {warningElement && (
            <div className="credit-info-warning">{warningElement}</div>
          )}
          <div className="credit-info-button">
            <CreditButton style={{ fontSize: '12px' }} />
          </div>
        </>
      )}
    </div>
  );
};

export default CreditInfo;
